<template>

<div class="page work">

  <!-- MAIN LANDING SECTION -->
	<transition name="slide-up-in" appear>
	<section id="landing" class="block-image-hero">
		<div class="container">
			<span class="hero-background"></span>
			<ts-image :src="image1.url" :width="image1.size[0]" :height="image1.size[1]" :bg-color="image1.bgColor"></ts-image>
		</div>
	</section>
	</transition>


	<!-- TEXT -->
	<section id="section-1" class="block-text-overview">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-5" data-sal="slide-up" data-sal-delay="600" data-sal-duration="600" data-sal-easing="ease">
					<p class="meta">UX, UI, &amp; Brand</p>
					<h2>Evolution. Football</br>Club Management</h2>
					<p>Evolution is a large platform that provides boardrooms with the necessary information and tools to reduce risk and encourage smarter planning &amp; player purchasing decisions.</p>
					<p>I worked closely with The 21st Club to provide support for digital strategy, UX &amp; UI design and visualising sports data.</p>
					<p>This case study shows specifically the 'Planning' and 'Acquisition' modules of the platform. 'Planning' is is to create squad based scenarios and use analytics to predict future success. 'Acquisition' is an 83,000+ player database to search, discover and compare players.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGE -->
	<section id="section-2" class="block-image">
		<div class="container" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
      <!-- IMAGE 2 -->
      <ts-image :src="image2.url" :width="image2.size[0]" :height="image2.size[1]" :bg-color="image2.bgColor" dark-loader></ts-image>
		</div>
	</section>


	<!-- TEXT -->
	<section id="section-3" class="block-text-content border">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>AI Driven</br>Player Recommendations</h3>
					<p>Requiring an acquisition means to find a player that provides the best value for money at low risk, improving the buying club’s team.</p>
					<p>The 21st Club’s intelligent analytics consider a player’s physique, performance and market data to create suggestions.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGES -->
	<section id="section-4" class="block-image">
		<div class="container">
			<span class="background right"></span>
      <!-- IMAGE 3 -->
      <ts-image :src="image3.url" :width="image3.size[0]" :height="image3.size[1]" :bg-color="image3.bgColor"></ts-image>
		</div>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


	<!-- TEXT -->
	<section id="section-5" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Creating a Search Criteria</h3>
					<p>The buying club may already have a pre-conceived idea of requirements, either from independent research or by using the 21st Club's Evolution platform.</p>
					<p>I designed a simple filtering system allowing the user to construct criteria and search for results in real-time. Each filter type required a custom UI design solution that reflects the data best.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGE -->
	<section id="section-6" class="block-image multiple">
		<div class="container">
			<span class="background left"></span>
      <!-- IMAGE 4 -->
      <ts-image :src="image4.url" :width="image4.size[0]" :height="image4.size[1]" :bg-color="image4.bgColor"></ts-image>
      <!-- IMAGE 5 -->
      <ts-image :src="image5.url" :width="image5.size[0]" :height="image5.size[1]" :bg-color="image5.bgColor"></ts-image>
		</div>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


  <!-- TEXT -->
	<section id="section-7" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Supporting Data-Driven</br>Decision Making</h3>
					<p>Data is usually at the core of any business strategy decision and can provide the objective insight needed to make them.</p>
					<p>The player profile page is designed to evaluate the player's condition, performance, experience and how the opposing club compares to the buying club.</p>
					<p>Each chart type is colour coded to highlight risk and popularity for the player.</p>
				</div>
			</div>
		</div>
	</section>


  <!-- IMAGE -->
	<section id="section-8" class="block-image">
		<div class="container">
			<span class="background right"></span>
      <!-- IMAGE 6 -->
      <ts-image :src="image6.url" :width="image6.size[0]" :height="image6.size[1]" :bg-color="image6.bgColor"></ts-image>
		</div>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


  <!-- TEXT -->
	<section id="section-9" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Sophisticated</br>Scenario Planning</h3>
					<p>Football clubs can plan for the immediate future but with scenario planning they can plan for where they want to be by taking into account financial, age and squad depth analysis.</p>
				</div>
			</div>
		</div>
	</section>


  <!-- IMAGE -->
	<section id="section-10" class="block-image multiple">
		<div class="container">
			<span class="background left"></span>
      <!-- IMAGE 7 -->
      <ts-image :src="image7.url" :width="image7.size[0]" :height="image7.size[1]" :bg-color="image7.bgColor"></ts-image>
			<!-- IMAGE 8 -->
			<ts-image :src="image8.url" :width="image8.size[0]" :height="image8.size[1]" :bg-color="image8.bgColor" dark-loader></ts-image>
		</div>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


  <!-- TEXT -->
  <section id="section-11" class="block-text-content">
    <div class="container">
      <div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
          <h3>Research On-The-Go</h3>
          <p>With Evolution, people can take it on the go.</p>
          <p>The mobile format provides all the features of the desktop version ideal for research on the fly.</p>
        </div>
      </div>
    </div>
  </section>


  <!-- IMAGE -->
	<section id="section-12" class="block-image full multiple">
      <!-- IMAGE 9 -->
      <ts-image :src="image9.url" :width="image9.size[0]" :height="image9.size[1]" :bg-color="image9.bgColor" dark-loader></ts-image>
      <!-- IMAGE 10 -->
      <ts-image :src="image10.url" :width="image10.size[0]" :height="image10.size[1]" :bg-color="image10.bgColor" dark-loader></ts-image>
	</section>

  <ts-footer></ts-footer>


</div>


</template>


<script>

// @ is an alias to /src
import sal from 'sal.js'
import TsImage from '@/components/TSImage.vue'
import TsFooter from '@/components/TSFooter.vue'

import Image1 from "@/assets/images/works/acquisition/300-image-1.png"
import Image2 from "@/assets/images/works/acquisition/300-image-2.png"
import Image3 from "@/assets/images/works/acquisition/300-image-3.png"
import Image4 from "@/assets/images/works/acquisition/300-image-4.png"
import Image5 from "@/assets/images/works/acquisition/300-image-5.png"
import Image6 from "@/assets/images/works/acquisition/300-image-6.png"
import Image7 from "@/assets/images/works/acquisition/300-image-7.png"
import Image8 from "@/assets/images/works/acquisition/300-image-8.png"
import Image9 from "@/assets/images/works/acquisition/300-image-9.png"
import Image10 from "@/assets/images/works/acquisition/300-image-10.png"

export default {

  name: 'Works21stClubEvolution',

  data() {
    return {
      image1: {
        url: Image1,
        size: [2560, 1356],
        bgColor: "none",
      },
      image2: {
        url: Image2,
        size: [2560,1606],
        bgColor: "none"
      },
      image3: {
        url: Image3,
        size: [2560,1560],
        bgColor: "none"
      },
      image4: {
        url: Image4,
        size: [2560,1560],
        bgColor: "none"
      },
      image5: {
        url: Image5,
        size: [2560,1194],
        bgColor: "none"
      },
      image6: {
        url: Image6,
        size: [2560,1628],
        bgColor: "none"
      },
      image7: {
        url: Image7,
        size: [2560,1560],
        bgColor: "none"
      },
      image8: {
        url: Image8,
        size: [2560,1560],
        bgColor: "none"
      },
      image9: {
        url: Image9,
        size: [2880,1986],
        bgColor: "none"
      },
      image10: {
        url: Image10,
        size: [2880,4108],
        bgColor: "none"
      }
    }
  },

  components: {
    TsImage,
    TsFooter
  },

	mounted() {
    this.$root.$emit('show-shapes', false)
		sal({threshold: 0.10});
  }


}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@import "~@/assets/scss/_variables";
@import "~@/assets/scss/grid/_bootstrap-grid";

span.hero-background {
	background-color: #FF5F59;
}
span.background {
	background-color: #FF5F59;
}

</style>
